import AnalisaBarangJadiApi from './AnalisaBarangJadiApi';

export default AnalisaBarangJadiApi;
